import React from 'react';
import Modal from '../../../../Components/Modal';
import Grid from '../../../../Components/Formatting/Grid';
import ButtonRow from '../../../../Components/Button/ButtonRow';
import Money from '../../../../Components/Formatting/Money';
import DateTime from '../../../../Components/Formatting/DateTime';
import Button from '../../../../Components/Button/Button';
import { ucFirst } from '../../../../Services/helpers';

const PayoutInfo = ({payout, close}) => {
    return <Modal title="Payout details" isOpen={!!payout} setIsOpen={close} dismissible>
        {payout && <Grid items={[
            [
                <strong>Amount</strong>,
                <Money pence={payout?.amount} />
            ],
            [
                <strong>Started</strong>,
                <DateTime timestamp={payout?.created} hideTime />
            ],
            [
                <strong>Expected</strong>,
                <DateTime timestamp={payout?.arrival_date} hideTime />
            ],
            [
                <strong>Status</strong>,
                ucFirst(payout?.status.replace('_', ' '))
            ],
            [
                <strong>Statement</strong>,
                payout?.statement_descriptor
            ],
            [
                <strong>Failure message</strong>,
                payout?.failure_message,
                !!payout?.failure_message
            ],
        ]} />}
        <ButtonRow>
            <Button theme="light" onClick={close} label="Close" />
        </ButtonRow>
    </Modal>
}

export default PayoutInfo;
